import React from "react";

const Checkbox = (
    { label, value, setValue, inverse, flipped } : 
    { label: string, value: boolean, setValue: any, inverse?: boolean, flipped?: boolean }
) => {
    const Box = ({marginLeft} : {marginLeft?: number}) => {
        return (
            <div 
                style={{marginLeft: marginLeft ? marginLeft : '0'}} 
                className={`checkbox ${!!value ? 'checked' : ''}`} 
                onClick={() => setValue(!value)}
            >
                <div className="checkbox-dot"></div>
            </div>
        )
    }

    const Label = () => {
        return (
            <label 
                className="checkbox-label" 
                style={{marginLeft: '5px'}}
                onClick={() => setValue(!value)}
            >
                {label}
            </label>
        )
    }

    return (
        <div className={`checkbox-wrapper ${inverse ? 'checkbox-inverse' : ''}`}>
            {label && !flipped && <Label />}
            {!flipped && <Box marginLeft={10}/>}
            {flipped && <Box/>}
            {label && flipped && <Label />}
            <input type="checkbox" checked={value} onChange={() => {}}/>
        </div>
    );
}

export default Checkbox;